import type {
  AnalysisT,
  CreateAnalysisRequest,
  UpdateAnalysisQuestionRequest,
} from '@/features/Analysis/types';

import { defaultAxios } from '..';

const analysisService = {
  async createAnalysis(
    dashboard_alias: string,
    payload: CreateAnalysisRequest,
  ): Promise<AnalysisT> {
    const res = await defaultAxios.post(
      `/dashboards3/${dashboard_alias}/analysis`,
      payload,
    );
    return res.data;
  },
  async fetchAnalysis(analysis_alias: string): Promise<AnalysisT> {
    const res = await defaultAxios.get(`/analysis/${analysis_alias}`);
    return res.data;
  },
  async updateAnalysisTitle(
    dashboard_alias: string,
    analysis_alias: string,
    title: string,
  ): Promise<AnalysisT> {
    const res = await defaultAxios.patch(
      `/dashboards3/${dashboard_alias}/analysis/${analysis_alias}/title`,
      { title },
    );
    return res.data;
  },
  async updateAnalysisQuestion(
    dashboard_alias: string,
    analysis_alias: string,
    params: UpdateAnalysisQuestionRequest,
  ): Promise<AnalysisT> {
    const res = await defaultAxios.patch(
      `/dashboards3/${dashboard_alias}/analysis/${analysis_alias}/question`,
      params,
    );

    return res.data;
  },
  async syncAnalysis(
    dashboard_alias: string,
    analysis_alias: string,
  ): Promise<AnalysisT> {
    const res = await defaultAxios.post(
      `/dashboards3/${dashboard_alias}/analysis/${analysis_alias}/sync`,
    );
    return res.data;
  },
  async syncAnalysisAll(dashboard_alias: string): Promise<{
    fail_ids: string[];
    success_ids: string[];
  }> {
    const res = await defaultAxios.post(
      `/dashboards3/${dashboard_alias}/analysis/sync`,
    );
    return res.data;
  },
  async updateAnalysisSetting(
    dashboard_alias: string,
    schedule: Schedule,
    enable: boolean,
  ): Promise<AnalysisT[]> {
    const res = await defaultAxios.put(
      `/dashboards3/${dashboard_alias}/analysis-schedule`,
      {
        schedule,
        enable,
      },
    );
    return res.data;
  },
};

export default analysisService;
